import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=b992c508&scoped=true&"
import script from "./step5.vue?vue&type=script&lang=js&"
export * from "./step5.vue?vue&type=script&lang=js&"
import style0 from "./step5.vue?vue&type=style&index=0&id=b992c508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b992c508",
  null
  
)

export default component.exports